import React, {useEffect} from 'react'

interface SelectionBtnsProps {
  selectionData: any,
  dataColors: any,
  selectionBtnName: any,
  handleMenuSelection: any,
}

const SelectionBtnsMobile = ({selectionData, dataColors, selectionBtnName, handleMenuSelection}: SelectionBtnsProps) => {


  const changeIconColor = (payload: string) => {
    var svgObj: any = document.getElementById('selected-btn');
    if(svgObj){
        var svgDoc = svgObj.contentDocument
        var paths = svgDoc.querySelectorAll('path')
        paths.forEach((path: any) => {
            path.setAttribute('fill',dataColors.secondary_text)
        })
    }
}

  useEffect(() => {
      var svgObj: any = document.querySelectorAll('#unselected-btn');
      if(svgObj){
          svgObj.forEach((obj: any) => {
              var svgDoc = obj.contentDocument
              var paths = svgDoc.querySelectorAll('path')
              paths.forEach((path: any) => {
                  path.setAttribute('fill',dataColors.main_text)
              })
          })
      }
      var svgObj2: any = document.getElementById('selected-btn');
        if(svgObj2){
            var svgDoc = svgObj2.contentDocument
            var paths = svgDoc.querySelectorAll('path')
            paths.forEach((path: any) => {
                path.setAttribute('fill',dataColors.secondary_text)
            })
        }
  }, [selectionBtnName, dataColors])

  return(
    <div className='selection-btn-container-mobile'>
      {
        selectionData ? selectionData.map((btn: any, index: number) => 
          <div
            className='individual-selection-btn-mobile'
            onClick = {selectionBtnName === btn.slug ?  () => {handleMenuSelection("")}:
            () => {
              handleMenuSelection(btn.slug)
              setTimeout(() => {
                changeIconColor(btn.slug)
            }, 100) 
            }}
            style = {{
              backgroundColor: 
                  selectionBtnName === btn.slug ? 
                  dataColors.main_buttons:"",
              transition: "all 0.2s ease-in-out"
          }}
          >
            <object 
            type="image/svg+xml" 
            data={btn.icono} 
            className="svg-img" 
            id = {selectionBtnName === btn.slug ? 'selected-btn':'unselected-btn'}
            style={{
              pointerEvents: 'none'
            }}
            onClick = {selectionBtnName === btn.slug ?  
              () => {
                  handleMenuSelection("")
                  changeIconColor(btn.slug)
              }:
              () => {
                  handleMenuSelection(btn.slug)
                  setTimeout(() => {
                      changeIconColor(btn.slug)
                  }, 100) 
              }}
            >.</object>
                    <div 
                        className='selection-btn-name' 
                        style={{
                            color: selectionBtnName === btn.slug ? dataColors.secondary_text: dataColors.main_text
                        }}
                    >
                        {btn.name}
                    </div>
          </div>
        ):null
      }
    </div>
  )
}

export default SelectionBtnsMobile